import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
  RESOURCES_COMPONENT_TOKEN,
  ResourcesComponent,
} from '@cgs/machines';
import { Compatibility, Container, debounce, SceneObject, viewportChangeListener } from '@cgs/wge';

enum SceneStates {
  Default = 'default',
  FreeSpins = 'free_game',
  FreeSpinsLabels = 'fs',
}

export class SantaBackgroundImageComponent {
  private readonly backgroundScene: SceneObject;
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;
  private freeSpinsLabels: SceneObject[] | null;

  constructor(container: Container) {
    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    const resourceComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this.backgroundScene = resourceComponent.bg;

    this.freeSpinsLabels = resourceComponent.slot.findAllById('fs_tooltips');

    this.gameStateMachine.init.entered.listen(() => this.setBaseGame());

    this.gameStateMachine.freeSpinsRecovery.entered.listen(() => this.setFreeSpins());
    this.gameStateMachine.endFreeSpinsPopup.leaved.listen(() => this.setBaseGame());

    viewportChangeListener.on(debounce(() => this.onResize(), 100));
  }

  private onResize(): void {
    const bgSet = this.backgroundScene?.findById('bgSet');
    const isFreeSpins =
      bgSet?.stateMachine?.isActive(`${SceneStates.FreeSpins}_vertical`) ||
      bgSet?.stateMachine?.isActive(`${SceneStates.FreeSpins}_horizontal`) ||
      false;

    if (isFreeSpins) {
      this.setFreeSpins();
      return;
    }

    this.setBaseGame();
  }

  public setBaseGame(): void {
    this.setState(SceneStates.Default);
    this.setFreeSpinsLabels(SceneStates.Default);
  }

  public setFreeSpins(): void {
    this.setState(SceneStates.FreeSpins);
    this.setFreeSpinsLabels(SceneStates.FreeSpins);
  }

  private setState(state: SceneStates): void {
    const suffix = Compatibility.isPortrait ? 'vertical' : 'horizontal';
    const bgSet = this.backgroundScene?.findById('bgSet');
    bgSet?.stateMachine?.switchToState(`${state}_${suffix}`);
  }

  private setFreeSpinsLabels(state: SceneStates): void {
    if (this.freeSpinsLabels) {
      for (const label of this.freeSpinsLabels) {
        label.stateMachine?.switchToState(state);
      }
    }
  }
}
